import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { route } from "preact-router";
import { Button, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";

import { SessionContext } from "../../SessionContext";
import EventsTimeLineCard from "../Common/EventsTimeLineCard";
import PersonnalCard from "../Common/PersonnalCard";
import SellerDealsCard from "../Common/SellerDealsCard";


import { AppContext } from "../../AppContext";

import MentoringCard from "../Common/MentoringCard";
//import { dedupArrayOfObjects, addFromToURL } from "../Common/functions";
import { redThreadUser } from "../Common/redthread";

export default function DashboardSeller(props) {
	const [state, setState] = useState({ ctx: undefined });
	const app = useContext(AppContext);
	const [session, setSession] = useContext(SessionContext);
	useEffect(() => {

		//console.log("session context", session, state)
		if (!session.ctx) { return }
		let topic = "room:udv-" + state.ctx.uid
		if (session.socket && state.ctx && session[topic] === undefined) {

			let channel = session.socket.channel(topic, {})

			channel.on("new_msg",
				msg => {
					console.log("Got message", msg)
					switch (msg.t) {
						case "user":

							setState((state) => ({
								...state,
								ctx: msg.p,
							}));
							break;

						default:

							break;
					}
				})

			channel.join()
				.receive("ok", ({ messages }) => {
					//console.log("catching up for ", messages, "room:ud-" + state.ctx.uid)
					setSession({ ...session, [topic]: channel })
				})
				.receive("error", ({ reason }) => console.log("failed join", reason))
				.receive("timeout", () => console.log("Networking issue. Still waiting..."))

		}
	}, [session, state]);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/32f45a786ece43fda155b9972c975f8a", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							ctx: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	useEffect(() => {

		redThreadUser(state, app, "vendeur");

	}, [state]);

	if (state.ctx === undefined) {
		return false;
	}
	return (


		<Grid container spacing={1}>
			<Grid item xs={12}>
				<Paper style="padding: 10px">
					<Grid
						container
						style={{
							justifyContent: "space-between",
							alignItems: "center",
						}}
						spacing={2}
					>
						<Grid item key={0}>
							<Typography variant="h5">Bienvenue dans votre espace vendeur</Typography>
						</Grid>
					</Grid>
				</Paper>
			</Grid>
			<Grid item xs={12} md={6}>
				<Stack spacing={1} style="height: 100%;">
					<PersonnalCard user={state.ctx} role="VN" />
					<SellerDealsCard ctx={state.ctx} />
				</Stack>
			</Grid>
			<Grid item xs={12} md={6}>
				<Stack spacing={1}>
					{state.ctx && (
						<MentoringCard state={state} id={props.id} />
					)}

					<EventsTimeLineCard events={state.ctx.events} />
				</Stack>
			</Grid>
		</Grid>

	);
}
